// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React, { useEffect } from 'react';

import Form from '@cloudscape-design/components/form';


import {
    removeCookie,
    setDisplayName,
    setIdUser
} from '../../../commons/functions';
import { useGlobalState } from '../../../context/GlobalStateContext';

export const UserLogoffPage = () => {
    const { idUser, data, menu, parameters, version, loading, notifications, displayName } = useGlobalState();
    setIdUser(0)
    setDisplayName('')
    removeCookie("JWT");
    useEffect(() => {
        window.location.href = "#user/login"
    }, [idUser]);

    return (
        <Form></Form>
    );

};
